import { MessageFlow } from '../MessageFlow/model';
import { ElementsDefinition } from 'cytoscape';

const KEY_MESSAGE_FLOW = 'messageflow';

export const loadMessageFlow = (): MessageFlow.MessageFlow => {
    try {
        const serializedState = localStorage.getItem(KEY_MESSAGE_FLOW);

        if (serializedState ===  null) {
            return MessageFlow.emptyMessageFlow();
        }

        const data = JSON.parse(serializedState);

        const messageFlowData: ElementsDefinition = data.elements;

        return new MessageFlow.MessageFlow({elements: messageFlowData, watching: data.watching});
    } catch (err) {
        console.error(err);
        return MessageFlow.emptyMessageFlow();
    }
};

export const saveMessageFlow = (flow: MessageFlow.MessageFlow): void => {
    try {
        const serializedFlow = JSON.stringify({elements: flow.elements(), watching: flow.isWatching()});
        localStorage.setItem(KEY_MESSAGE_FLOW, serializedFlow);
    } catch (err) {
        console.error(err);
        // @TODO: Better handling for write errors
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/localStorage.ts